(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-faq-dynamic"]) return;
  try {
    
(function() {
  var GAP = 16;
  var mobileNav = window.matchMedia('(max-width: 991.98px)');

  function topOffset(nav) {
    var offset = GAP;
    var header = document.querySelector('.section-header');
    if (header) offset += header.offsetHeight;
    // Below lg the sidebar stacks above the content and stays sticky, so it covers the target too.
    if (mobileNav.matches) {
      var sidebar = nav.closest('.sticky-top');
      if (sidebar) offset += sidebar.offsetHeight;
    }
    return offset;
  }

  document.querySelectorAll('[data-faq-dynamic-nav]').forEach(function(nav) {
    nav.addEventListener('click', function(evt) {
      var link = evt.target.closest('[data-faq-nav]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('data-faq-nav'));
      nav.querySelectorAll('[data-faq-nav]').forEach(function(el) { el.classList.remove('active'); });
      link.classList.add('active');
      if (!target) return;
      evt.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - topOffset(nav);
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      history.replaceState(null, '', '#' + target.id);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
